module.exports = __webpack_public_path__ + "img/indoguna.c8d199f0.png";